import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Text, { CaptionProps, TinyProps } from '~/components/typographies/Text';
import BadgeLabel from './BadgeLabel';
import styles from './NewFeatureBadge.module.scss';

interface Props {
  size?: 'small' | 'medium';
  className?: string;
}

export const NewFeatureBadge = ({ size = 'medium', className }: Props) => {
  const { t } = useTranslation();
  const textProps: TinyProps | CaptionProps =
    size === 'small' ? { variant: 'tiny', weight: 'bold' } : { variant: 'caption', weight: 'semibold' };

  return (
    <BadgeLabel className={clsx(styles.badge, styles[size], className)}>
      <Text {...textProps}>{t('NEW')}</Text>
    </BadgeLabel>
  );
};
